// Single source of truth for product pricing. Edit here — /pricing and all
// product surfaces pull from this file.
export const PRICING = [
  {
    name: "Financial Profile Development",
    checkoutId: "financial-profile-development",
    priceLine: "$199 onboarding, billed when your roadmap is delivered. Then $149/mo, billed after each month's work",
    detail: "Strategic development of your financial profile with monthly milestone reviews.",
  },
  {
    name: "Personal Capital Strategy",
    checkoutId: "personal-capital-strategy",
    priceLine: "10% of capital received, $500 minimum, invoiced after your capital closes",
    detail: "Personal capital strategy engagement — you pay only after results.",
  },
  {
    name: "Business Capital Strategy",
    checkoutId: "business-capital-strategy",
    priceLine: "10% of capital received, $500 minimum, invoiced after your capital closes",
    detail: "Business capital strategy engagement — you pay only after results.",
  },
  {
    name: "Account History Positioning",
    checkoutId: "profile-positioning",
    priceLine: "Starting at $497 per authorized user account",
    detail: "Established-account positioning placements matched to your profile.",
  },
  {
    name: "Grant Readiness & Research",
    checkoutId: "grant-readiness",
    priceLine: "$497 research + $997 per application",
    detail: "Grant research tailored to your business, plus full application preparation.",
  },
  {
    name: "Business Foundation Setup",
    checkoutId: "business-foundation",
    priceLine: "$497 + state fees at cost",
    detail: "Entity formation, EIN, and foundational business setup.",
  },
];

export const priceLineFor = (name) => PRICING.find((p) => p.name === name)?.priceLine || null;
